<template>
    <div class="row">
        <div class="col-12 mb-1">
            <div class="col-12 mb-1">
                <label class="form-label">Kullanıcı</label>
                <v-select-list :options="users" v-model="user" placeholder="Kullanıcı" label="FullName"></v-select-list>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">İzin Türü</label>
                <v-select-list :options="excuseTypes" v-model="excuseType" placeholder="İzin Türü" label="Name"></v-select-list>
            </div>
            <div class="col-md-12">
                <label class="form-label">Tarih Aralığı</label>
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>        
            </div>
        </div>
       
    </div>
</template>

<script>
import { UserApi } from '@/api/user'
import { UserExcuseApi } from '@/api/user-excuse'
export default {
    props:{
        value:Object
    },
    data(){
        return{
            users:[],
            excuseTypes:[]
        }
    },
    mounted(){
        this.getUsers()
        this.getExcuseTypes()
    },
    methods:{
        getCurrentMonthDateRange(){
            let date = new Date();
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [firstDay,lastDay]
        },
        getUsers(){
            UserApi.List().then(res=>{
                this.users = res.data.Data
            })
        },
        getExcuseTypes(){
            UserExcuseApi.Type.List().then(res=>{
                this.excuseTypes = res.data.Data
            })
        },
    },
    computed:{
        user:{
            get:function(){
                return this.users.find(r=>r.Id == this.value.UserId)
            },
            set:function(value){
                this.value.UserId = value?.Id || null
            }
        },
        excuseType:{
            get:function(){
                return this.excuseTypes.find(r=>r.Id == this.value.UserExcuseTypeId)
            },
            set:function(value){
                this.value.UserExcuseTypeId = value?.Id || null
            }
        },
        date:{
            get:function(){
                return [this.value.StartDate,this.value.EndDate].filter(d=>d != null)
            },
            set:function(val){
                this.value.StartDate = val[0] || null
                this.value.EndDate = val[1] || null
            }
        },
    }
}
</script>

<style>

</style>